import {
  Component,
  Input,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'conn-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TooltipComponent {
  // This tooltipText can be a reference to an Ng-template tag if you want to include html or it could be a simple
  // string
  @Input() tooltipText: TemplateRef<unknown> | string = '';
  @Input() placement = 'top';
  /**
   * an optional delay in MS that the pop-up message will stay on the screen.  By default, this is 250 MS
   */
  @Input() openDelay = 250;
  @Input() closeDelay = 250;

  constructor() {}
}
